module.exports = __webpack_public_path__ + "static-portal/img/map-m.65b3f03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map-m.png
// module id = IuqY
// module chunks = 4